export default __webpack_public_path__ + "400cdada9910564e4151946fc5f6b0ba.svg";